import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { GlobalsService } from '../../services/globals.service';
import { DataVehiculosService } from '../../../dms/modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';
import { SendDataService } from '../gestion-form/services/send-data.sevice';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { environment } from '../../../../environments/environment';
import { GestionOrService } from '../../../dms/modulos/taller/componentes/gestion-or/gestion-or.service';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { DataSaveService } from '../../services/data-save.service';
import { RedirectService } from '../../services/redirect.service';
import { delay } from 'rxjs/operators';
import { StorageEnum } from '../../enums/storage.enum';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { ChildsMenuEnum } from '../../enums/childs-menu.enum';
import { ImpresosEnum } from '../../enums/imprimir.enum';
import { ImprimirService } from '../../services/imprimir.service';
let OrdenReparacionComponent = class OrdenReparacionComponent {
    constructor(router, _storageService, _dataSaveService, _imprimirService, _gestionOrService, _authService, translate, _dataVehiculosService, _globals, _sendData, _redirectService, _storage) {
        this.router = router;
        this._storageService = _storageService;
        this._dataSaveService = _dataSaveService;
        this._imprimirService = _imprimirService;
        this._gestionOrService = _gestionOrService;
        this._authService = _authService;
        this.translate = translate;
        this._dataVehiculosService = _dataVehiculosService;
        this._globals = _globals;
        this._sendData = _sendData;
        this._redirectService = _redirectService;
        this._storage = _storage;
        this.cancel = new EventEmitter();
        this.desactivarBotonGOR = true;
        this.searchValue = '';
        this.searchQuery = '';
        this.historyInterventions = false;
        this.ordenRep = [
            {
                title: '',
                th: ['labels.num_orden', 'labels.f_recepcion', 'labels.f_entrega', 'labels.estado', 'labels.facturas', 'labels.tipo', 'labels.km'],
                fields: ['order', 'reception', 'delivery', 'state', 'factura', 'tipo', 'Km']
            }
        ];
        this.history = [
            {
                title: '',
                th: ['labels.num_orden', 'gestion_vehiculos.table_th.fechaDocumentacion', 'labels.descripcion', 'labels.referencia', 'gestion_vehiculos.table_th.operationGV', 'labels.cant', 'Km'],
                fields: ['orden', 'historicData', 'ReceptionLineDescription', 'ReferenceCode', 'ReferenceDescription', 'Units', 'KM']
            }
        ];
        this.lRecepcion = [
            {
                title: '',
                th: ['labels.descripcion', 'labels.taller'],
                fields: ['Description', 'WorkingSection.WorkingSectionDescription']
            }
        ];
        this.facturas = [
            {
                title: '',
                th: ['labels.num_de_factura', 'labels.importe'],
                fields: ['factura', 'DocumentTotal']
            }
        ];
        this.lInputacion = [
            {
                title: '',
                th: ['gestion_vehiculos.table_th.imputType', 'labels.referencia', 'gestion_vehiculos.table_th.operationGV', 'labels.cant', 'labels.precio', 'labels.Dto', 'labels.importe'],
                fields: ['DetailTypeDesc', 'ItemCode', 'Description', 'Units', 'Price', 'Discount', 'ClearPrice'],
                width: ['80', '40', '40', '40', '40', '40', '40']
            }
        ];
        this.ordenesAbiCurCerr = [];
        this.childs = [];
        this.kendoPagerSettings = {
            buttonCount: 5,
            info: true,
            type: 'numeric',
            pageSizes: true,
            previousNext: true
        };
        this.gestionTerceros = false;
        this.isLoading = false;
        this.isLoadingSearch = false;
        this.WorkLineID = null;
        this.ordenReparacion = {
            'type': '',
            'productionOrderPrefix': '',
            'productionOrderNumber': '',
            'productionOrderDate': '',
            'productionOrderYear': ''
        };
        this.ordenReparacionDetail = {
            'wareHouseNumber': '',
            'repairOrderDate': '',
            'repairOrderPrefix': '',
            'repairOrderNumber': ''
        };
    }
    ngOnInit() {
        this.paginacionInicial();
        this.crearForm();
        this.cargarTextos();
        this.userProfile = this._authService.getDataContents();
        this.childs = this.userProfile.AppModules;
        this.moduloTaller = this.childs[3];
        this.moduloFacturas = this.childs[4];
        this.vistaNavigate = 1;
        switch (this.transmitter) {
            case 'gestionTerceros':
                this.gestionTerceros = true;
                this.stockVO = false;
                this.gestionVehiculos = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.ordenRep[0]['height'] = 110;
                this.history[0]['height'] = 240;
                this.lRecepcion[0]['height'] = 75;
                this.facturas[0]['height'] = 75;
                this.lInputacion[0]['height'] = 162;
                this.chassis = this._dataSaveService.getChassis('gestionTerceros').chassis;
                if (this.chassis && !this.comprobarObjeto(this.chassis)) {
                    this.datosChassis(this.chassis);
                }
                break;
            case 'stockVO':
                this.gestionTerceros = false;
                this.stockVO = true;
                this.gestionVehiculos = false;
                this.gestionOr = false;
                this.gestionVehiculosCortesia = false;
                this.ordenRep[0]['height'] = 80;
                this.history[0]['height'] = 210;
                this.lRecepcion[0]['height'] = 60;
                this.facturas[0]['height'] = 60;
                this.lInputacion[0]['height'] = 130;
                this.chassis = this._dataSaveService.getChassis('stockVO').chassis;
                if (this.chassis && !this.comprobarObjeto(this.chassis)) {
                    this.datosChassis(this.chassis);
                }
                break;
            case 'gestionVehiculos':
                this.gestionTerceros = false;
                this.stockVO = false;
                this.gestionVehiculos = true;
                this.gestionOr = false;
                this.gestionVehiculosCortesia = false;
                this.ordenRep[0]['height'] = 125;
                this.history[0]['height'] = 210;
                this.lRecepcion[0]['height'] = 60;
                this.facturas[0]['height'] = 60;
                this.lInputacion[0]['height'] = 130;
                this.chassis = this._dataSaveService.getChassis('gestionVehiculos').chassis;
                if (this.chassis && !this.comprobarObjeto(this.chassis)) {
                    this.datosChassis(this.chassis);
                }
                break;
            case 'gestionVehiculosCortesia':
                this.gestionTerceros = false;
                this.stockVO = false;
                this.gestionVehiculos = false;
                this.gestionOr = false;
                this.gestionVehiculosCortesia = true;
                this.ordenRep[0]['height'] = 80;
                this.history[0]['height'] = 210;
                this.lRecepcion[0]['height'] = 60;
                this.facturas[0]['height'] = 60;
                this.lInputacion[0]['height'] = 130;
                this.chassis = this._dataSaveService.getChassis('gestionVehiculosCortesia').chassis;
                if (this.chassis && !this.comprobarObjeto(this.chassis)) {
                    this.datosChassis(this.chassis);
                }
                break;
            case 'gestionOr':
                this.gestionTerceros = false;
                this.stockVO = false;
                this.gestionVehiculos = false;
                this.gestionOr = true;
                this.gestionVehiculosCortesia = false;
                this.ordenRep[0]['height'] = 80;
                this.history[0]['height'] = 210;
                this.lRecepcion[0]['height'] = 60;
                this.facturas[0]['height'] = 60;
                this.lInputacion[0]['height'] = 130;
                break;
        }
    }
    paginacionInicial() {
        this.skipH = 0;
        this.pageNumberH = 1;
        this.pageSizeH = 20;
        this.objetoPaginacion = {
            'skip': this.skipH,
            'Number': this.pageNumberH,
            'Size': this.pageSizeH
        };
        this.skipOR = 0;
        this.pageNumberOR = 1;
        this.pageSizeOR = 5;
        this.objetoPaginacionOR = {
            'skip': this.skipOR,
            'Number': this.pageNumberOR,
            'Size': this.pageSizeOR
        };
    }
    pageChangeOR(event) {
        this.skipOR = event.skip;
        this.pageSizeOR = event.take;
        this.pageNumberOR = 1;
        if (event) {
            this.pageNumberOR = event.skip / this.pageSizeOR + 1;
        }
        else {
            this.skipOR = 0;
        }
        this.objetoPaginacionOR = {
            'skip': this.skipOR,
            'Number': this.pageNumberOR,
            'Size': this.pageSizeOR
        };
        this.sacarHistorialOrdenes();
    }
    pageChangeH(event) {
        this.skipH = event.skip;
        this.pageSizeH = event.take;
        this.pageNumberH = 1;
        if (event) {
            this.pageNumberH = event.skip / this.pageSizeH + 1;
        }
        else {
            this.skipH = 0;
        }
        this.objetoPaginacion = {
            'skip': this.skipH,
            'Number': this.pageNumberH,
            'Size': this.pageSizeH
        };
        this.search();
    }
    rellenarTabla(items, objetoPaginacion) {
        this.history[0]['gridView'] = {
            data: items,
            total: objetoPaginacion.TotalElements
        };
    }
    rellenarTablaOR(items, objetoPaginacionOR) {
        this.ordenRep[0]['gridView'] = {
            data: items,
            total: objetoPaginacionOR.TotalElements
        };
    }
    crearForm() {
        this.searchForm = new FormGroup({
            searchValue: new FormControl()
        });
        this.searchForm.valueChanges.pipe(delay(1000)).subscribe(() => {
            this.search();
        });
    }
    editHandler({ sender, rowIndex, dataItem }) {
        this.RowData = dataItem;
        this._dataVehiculosService.setFactura(this.RowData);
        const auxtoFacturas = {
            ClientCode: this.clientCode,
            InvoiceID: this.RowData.ID,
            InvoicePayType: this.ordenSeleccionada.WorkType,
            InvoiceType: this.ordenSeleccionada.StateCode,
            Date: this.RowData.DocumentData,
            RepairNumber: this.ordenSeleccionada.RepairNumber,
            RepairPrefix: this.ordenSeleccionada.RepairPrefix
        };
        const toFacturas = JSON.stringify(auxtoFacturas);
        this._storage.setParam(StorageEnum.REDIRECT_GESTION_VEHICULOS, toFacturas);
        this.router.navigate(['dms/invoices/facturacion-operaciones']);
        /* const params = { SELECTFACTOPER: toFacturas };
        this._redirectService.redirectionFacturacion(this.moduloFacturas, 4001, params); */
    }
    comprobarObjeto(item) {
        const auxItemString = JSON.stringify(item);
        const auxObjetoVacio = '{}';
        if (auxItemString === auxObjetoVacio) {
            return true;
        }
        else {
            return false;
        }
    }
    cargarTextos() {
        this.translate.get('labels.presupuesto_abi').subscribe(rest => (this.presupuestoAbi = rest));
        this.translate.get('labels.presupuesto_no_acep').subscribe(rest => (this.presupuestoNoAcep = rest));
        this.translate.get('labels.presupuesto_acep').subscribe(rest => (this.presupuestoAcep = rest));
        this.translate.get('labels.presupuesto_cerr').subscribe(rest => (this.presupuestoCerra = rest));
        this.translate.get('labels.presupuesto_curso').subscribe(rest => (this.presupuesto_encurso = rest));
        this.translate.get('labels.presupuesto_anu').subscribe(rest => (this.presupuestoAnu = rest));
        this.translate.get('labels.facturada').subscribe(rest => (this.facturada = rest));
        this.translate.get('labels.anulada').subscribe(rest => (this.anulada = rest));
        this.translate.get('labels.abierta').subscribe(rest => (this.abierta = rest));
        this.translate.get('labels.cerrada').subscribe(rest => (this.cerrada = rest));
        this.translate.get('labels.encurso').subscribe(rest => (this.encurso = rest));
        this.translate.get('labels.facturada_parc').subscribe(rest => (this.facturadaParc = rest));
        this.translate.get('labels.pendiente_fact').subscribe(rest => (this.pendienteFac = rest));
        this.translate.get('labels.cerrada').subscribe(rest => (this.presupuestoCerra = rest));
        this.translate.get('labels.reabierta').subscribe(rest => (this.reabierta = rest));
        this.translate.get('labels.presupuesto_no_acep').subscribe(rest => (this.presupuestoNo = rest));
        this.translate.get('labels.ciservice').subscribe(rest => (this.presupuesto_ci = rest));
    }
    datosChassis(chassis) {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes`;
        const parametros = {
            'searchValue': chassis
        };
        this._dataVehiculosService.getCarByChassis(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.carData = auxdata;
                this.lastRepair = this.carData['LastRepairOrder'];
                if (this.lastRepair) {
                    this.ordenReparacion = {
                        'type': this.lastRepair['RepairType'],
                        'productionOrderPrefix': this.lastRepair['RepairPrefix'],
                        'productionOrderNumber': this.lastRepair['RepairNumber'],
                        'productionOrderDate': this.lastRepair['RepairData'],
                        'productionOrderYear': null
                    };
                    this.ordenReparacionDetail = {
                        'wareHouseNumber': this.lastRepair['WareHouseNumber'],
                        'repairOrderDate': this.lastRepair['RepairData'],
                        'repairOrderPrefix': this.lastRepair['RepairPrefix'],
                        'repairOrderNumber': this.lastRepair['RepairNumber']
                    };
                }
            }
            this.sacarHistorialOrdenes();
            this.isLoading = false;
        });
    }
    cargarTablas() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isLoadin123 = true;
            try {
                const productionOrder = yield this.GetByProductionOrderNumberComplete();
                this.getProductionOrderDetailsView();
            }
            catch (error) {
            }
        });
    }
    // Paso 2 (vistaNavigate===1) tabla 2 y 3  Listado de Lineas de Recepcion y Facturas
    GetByProductionOrderNumberComplete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _URL_ = `${environment.ENTORNO}Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete`;
            const productionOrderFetch = this._gestionOrService.getDataOrders(_URL_, this.ordenReparacion).subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.datosCustomDialog = auxdata;
                    this.workLineList = auxdata.WorkLineList; // en el array de WorkLineList sale el Id para seleccionar this.WorkLineID
                    this.clientCode = auxdata.CustomerSearchClientCode;
                    this.lRecepcion[0]['gridView'] = {
                        data: this.workLineList,
                        total: this.workLineList.length
                    };
                    this.invoiceSaleHeaderList = auxdata.InvoiceSaleHeaderList;
                    this.invoiceSaleHeaderList.forEach(item => {
                        item.factura = item['DocumentPrefix'] + '-' + item['DocumentNumber'];
                    });
                    this.facturas[0]['gridView'] = {
                        data: this.invoiceSaleHeaderList,
                        total: this.invoiceSaleHeaderList.length
                    };
                }
            });
            return productionOrderFetch;
        });
    }
    search() {
        this.vistaNavigate = 2;
        this.searchQuery = this.searchForm.get('searchValue').value;
        this.isLoadingSearch = true;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/CarHistorySearch`;
        const paramsPrint = {
            chassis: this.chassis,
            searchValue: this.searchQuery,
            pageInfo: {
                Number: this.objetoPaginacion.Number,
                Size: this.objetoPaginacion.Size
            }
        };
        this._dataVehiculosService.getHistoricSearch(_URL_, paramsPrint).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.objetoPaginacion = data.Response.pageInfo;
                this.historicList = auxdata;
                this.historicList.forEach(item => {
                    item.orden = item['DocumentPrefix'] + '-' + item['DocumentNumber'];
                    item.historicData = this._globals.getDateFormatMDY(item.DocumentDate);
                    item.Units = this.dosDecimalesMasTipo(item.Units, item.UnitDetailDescription);
                });
                this.rellenarTabla(this.historicList, this.objetoPaginacion);
            }
            setTimeout(() => {
                this.isLoadingSearch = false;
            }, 100);
        });
    }
    dosDecimalesMasTipo(dato1, dato2) {
        let auxDato1 = parseFloat(dato1).toFixed(2);
        auxDato1 = auxDato1 + ' ' + dato2;
        return auxDato1;
    }
    printInforme() {
        const printParams = {
            type: ImpresosEnum.printCarHistory,
            chassis: this.chassis,
            searchValue: this.searchQuery ? this.searchQuery : ''
        };
        this._imprimirService.descargarImpreso(printParams, null);
    }
    // Paso 2 (vistaNavigate===1) tabla 3  Listado de Lines de Imputacion
    getProductionOrderDetailsView() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/RepairOrderService.svc/GetProductionOrderDetailsView`;
        this._gestionOrService.getProductionOrderDetailsView(_URL_, this.ordenReparacionDetail).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.orderDetailsView = auxdata;
                this.orderDetailsView.forEach(d => {
                    d.tipoCantidad = this.aplicarTipo(d.MeasureUnitCode);
                });
                this.lInputacion[0]['gridView'] = {
                    data: this.orderDetailsView,
                    total: this.orderDetailsView.length
                };
            }
            this.isLoadin123 = false;
        });
    }
    recepcionVehiculo() {
        this._authService.setCurrentModule(this.moduloTaller);
        const params = { VIN: this.carData.Vin };
        localStorage.setItem('SearchVin', this.carData.Vin);
        this._redirectService.redirectionTaller(this.moduloTaller, 3002, params);
    }
    gestionOR() {
        const data = {
            step: 1,
            selectedRow: {
                RepairData: this.ordenSeleccionada.RepairData,
                RepairNumber: this.ordenSeleccionada.RepairNumber,
                RepairPrefix: this.ordenSeleccionada.RepairPrefix,
                RepairType: this.ordenSeleccionada.RepairType,
                WareHouseNumber: this.ordenSeleccionada.WareHouseNumber
            }
        };
        this._storageService.setParam(StorageEnum.GESTION_OR, data);
        this._redirectService.redirectionTaller(this.moduloTaller, ChildsMenuEnum.GESTION_OR);
        // this.router.navigate(['dms/workshop/gestion-or']);
    }
    aplicarTipo(tipo) {
        switch (tipo) {
            case 'VOLUMEN':
                return 'L';
            case 'UNIDAD':
                return 'Uni.';
            default:
                return 'Uni';
        }
    }
    comprobarStatusOrdenes(arrayordenes) {
        this.hayOrdenesAbiertas = false;
        this.ordenesAbiCurCerr = [];
        arrayordenes.forEach(item => {
            if (item.StateCode === 'AB' || item.StateCode === 'CC' || item.StateCode === 'EC') {
                this.ordenesAbiCurCerr.push(item);
            }
        });
        if (this.ordenesAbiCurCerr.length > 0) {
            this.hayOrdenesAbiertas = true;
            this._dataVehiculosService.setOrdenesAbiertas(this.ordenesAbiCurCerr);
        }
    }
    // Paso 2 (vistaNavigate===1) tabla 1 Listado de OR
    sacarHistorialOrdenes() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetProductionOrderHistory`;
        const parametros = {
            chassis: this.chassis,
            // plate: this.carData.PlateNumber,
            // vin: this.carData.Vin,
            pageInfo: {
                Number: this.objetoPaginacionOR.Number,
                Size: this.objetoPaginacionOR.Size
            }
        };
        this._sendData.getOrHistory(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata && auxdata.length > 0) {
                const dataOr = auxdata;
                this.objetoPaginacionOR = data.Response.pageInfo;
                dataOr.forEach(item => {
                    let factura, state, order;
                    if (item['StateCode']) {
                        if ((item['Source'] === 1 || item['Source'] === "1" && item['RepairPrefix'] === "PO")) {
                            state = this.getFactTranslate('PICI'); // Presupuesto CIService
                        }
                        else if (item['StateCode'] === 'PI' && (item['Source'] === null || item['Source'] === 0)) {
                            state = this.getFactTranslate('AN'); // ANULADA
                        }
                        else {
                            state = this.getFactTranslate(item['StateCode']); // a veces StateCode
                        }
                    }
                    if (item['RepairPrefix'] && item['RepairNumber']) {
                        order = item['RepairPrefix'] + '-' + item['RepairNumber']; // a veces
                    }
                    if (item.InvoiceSaleHeaderList.length === 0) {
                        factura = '';
                    }
                    else {
                        factura = this.sumatorioFacturas(item.InvoiceSaleHeaderList);
                    }
                    item.order = order;
                    item.state = state;
                    item.reception = item.RepairData ? this._globals.getDateFormatMDY(item.RepairData) : '',
                        item.delivery = item.PreviewedDeliveryDate ? this._globals.getDateFormatMDY(item.PreviewedDeliveryDate) : '',
                        item.factura = factura;
                    item.tipo = item.WorkType ? item.WorkType.Description : null;
                });
                this.rellenarTablaOR(dataOr, this.objetoPaginacionOR);
                // Esto carga por defecto un row seleccionado
                // this.seleccionPorDefectoOr = dataOr[0];
                // this.selectOr( this.seleccionPorDefectoOr, 'pordefecto');
            }
        });
    }
    sumatorioFacturas(arrayFacturas) {
        let sumaFacturas = '';
        arrayFacturas.map(item => {
            const auxFactura = item['DocumentPrefix'] + '-' + item['DocumentNumber'] + '|';
            const auxFacturaString = auxFactura.toString();
            sumaFacturas = sumaFacturas.concat(auxFacturaString);
        });
        return sumaFacturas;
    }
    getFactTranslate(faType) {
        switch (faType) {
            case 'PA': // Presupuesto Abierto
                return this.presupuestoAbi;
            case 'PN': // Presupuesto No Aceptado
                return this.presupuestoNoAcep;
            case 'PC': // Presupuesto Aceptado
                return this.presupuestoAcep;
            case 'CE': // Presupuesto Cerrado
                return this.presupuestoCerra;
            case 'PE': // Presupuesto En curso
                return this.presupuesto_encurso;
            case 'PI': // Presupuesto Anulado. Solo se pueden anular presupuestos "Abiertos o en "En curso"
                return this.presupuestoAnu;
            case 'PICI': // Presupuesto CIService. Estado creado en sacarHistorialOrdenes()
                return this.presupuesto_ci;
            case 'AB':
                return this.abierta;
            case 'FA':
                return this.facturada;
            case 'AN':
                return this.anulada;
            case 'CC':
                return this.cerrada;
            case 'EC':
                return this.encurso;
            case 'FP':
                return this.facturadaParc;
            case 'RA':
                return this.reabierta;
            case 'PF':
                return this.pendienteFac;
            default:
                return faType;
        }
    }
    selectOr(event, tipo) {
        this.desactivarBotonGOR = false;
        let newData;
        if (tipo === 'tabla') {
            newData = event.dataItem;
        }
        else {
            newData = event;
        }
        this.ordenSeleccionada = event.dataItem;
        const auxFecha = this._globals.getDateFormatForServer(this.ordenSeleccionada.delivery);
        this.ordenReparacion = {
            'type': newData.RepairType,
            'productionOrderPrefix': newData.RepairPrefix,
            'productionOrderNumber': newData.RepairNumber,
            'productionOrderDate': newData.RepairData,
            'productionOrderYear': null
        };
        this.ordenReparacionDetail = {
            'wareHouseNumber': newData.WareHouseNumber,
            'repairOrderDate': newData.RepairData,
            'repairOrderPrefix': newData.RepairPrefix,
            'repairOrderNumber': newData.RepairNumber
        };
        this.cargarTablas();
    }
    cancelarOut() {
        this.cancel.emit(true);
    }
};
OrdenReparacionComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [Router,
        StorageService,
        DataSaveService,
        ImprimirService,
        GestionOrService,
        AuthService,
        TranslateService,
        DataVehiculosService,
        GlobalsService,
        SendDataService,
        RedirectService,
        StorageService])
], OrdenReparacionComponent);
export { OrdenReparacionComponent };
